<h1 mat-dialog-title>Terms and Conditions</h1>
<div mat-dialog-content [innerHTML]="agreementText"></div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
